import ReactDOM from 'react-dom';

const ModalPortal = ({ children }) => {
    const modalRoot = document.getElementById('modal-root');

    if (!modalRoot) return null;

    return ReactDOM.createPortal(
        <div data-prerender-remove="true">
            {children}
        </div>,
        modalRoot
    );
};

export default ModalPortal;